import * as React from 'react';
import { snap, story, visualize } from 'storybook-snapper';
import { ReviewSummary } from '..';
import { FavoriteFill } from '@wix/wix-ui-icons-common/on-stage';

const items = [
  {
    value: 678,
    max: 899,
    prefixIndication: <div>5 Stars</div>,
    showProgressIndication: true,
    customSuffixIndicationText: '678',
  },
  {
    value: 150,
    max: 899,
    prefixIndication: <div>4 Stars</div>,
    showProgressIndication: true,
    customSuffixIndicationText: '150',
  },
  {
    value: 44,
    max: 899,
    prefixIndication: <div>3 Stars</div>,
    showProgressIndication: true,
    customSuffixIndicationText: '44',
  },
  {
    value: 16,
    max: 899,
    prefixIndication: <div>2 Stars</div>,
    showProgressIndication: true,
    customSuffixIndicationText: '16',
  },
  {
    value: 11,
    max: 899,
    prefixIndication: <div>1 Stars</div>,
    showProgressIndication: true,
    customSuffixIndicationText: '11',
  },
];

const itemsWithIcons = [
  {
    value: 3500,
    max: 3740,
    prefixIndication: (
      <>
        <FavoriteFill color="lightgrey" height="16" width="16" />
        <FavoriteFill color="lightgrey" height="16" width="16" />
        <FavoriteFill color="lightgrey" height="16" width="16" />
      </>
    ),
    showProgressIndication: true,
    customSuffixIndicationText: '3500',
  },
  {
    value: 150,
    max: 3740,
    prefixIndication: (
      <>
        <FavoriteFill color="lightgrey" height="16" width="16" />
        <FavoriteFill color="lightgrey" height="16" width="16" />
      </>
    ),
    showProgressIndication: true,
    customSuffixIndicationText: '150',
  },
  {
    value: 90,
    max: 3740,
    prefixIndication: <FavoriteFill color="lightgrey" height="16" width="16" />,
    showProgressIndication: true,
    customSuffixIndicationText: '90',
  },
];

visualize('ReviewSummary', () => {
  story('simple', () => {
    snap('with prefix and suffix', <ReviewSummary items={items} />);
    snap('with prefix icons', <ReviewSummary items={itemsWithIcons} />);
    snap(
      'RTL',
      <div dir="rtl">
        <ReviewSummary items={itemsWithIcons} />
      </div>,
    );
    snap(
      'just prefix',
      <ReviewSummary
        items={items.map((i) => ({ ...i, showProgressIndication: false }))}
      />,
    );
    snap(
      'just suffix',
      <ReviewSummary
        items={items.map((i) => ({ ...i, prefixIndication: null }))}
      />,
    );
    snap(
      'just progress bar',
      <ReviewSummary
        items={items.map((i) => ({
          ...i,
          prefixIndication: null,
          showProgressIndication: false,
        }))}
      />,
    );
    snap(
      'wst theme',
      <div
        style={
          {
            '--wst-paragraph-2-color-rgb': '255,200,0',
            '--wst-paragraph-2-font-style': 'italic',
            '--wst-paragraph-2-font-family': 'Courier New',
            '--wst-paragraph-2-font-weight': '900',
            '--wst-links-and-actions-color-rgb': '00,220,200',
            '--wst-paragraph-2-font-size': '22px',
            '--wst-paragraph-2-font-variant': 'small-caps',
            '--wst-paragraph-2-line-height': '3',
          } as React.CSSProperties
        }
      >
        <ReviewSummary items={items} />
      </div>,
    );
  });
});
